import Clap from '../../assets/images/clap.png';
import Wow from '../../assets/images/wow.png';
import oneStep from '../../assets/images/one_step.png';
import { GAMIFIED_STEPS } from '../../redux/slicers/gamifySlicer';

export const GAMIFIED_ACTIVE = 'GAMIFIED_ACTIVE';

export const INITIAL_STEP = 'SELECT_ANY_PROP';

export const INITIAL_COORDINATES = { top: '200px', left: '1000px' };

export const TOOLTIP_STEPS = {
  SELECT_ANY_PROP: {
    title: 'Right Click on Me!',
    content: 'Right click to see number of things we can do with this prop.',
    styles: {
      width: '279px',
      transform: 'translate(-50%, calc(-100% - 10px))',
    },
    mainStep: GAMIFIED_STEPS.PRODUCT,
    progress: 10,
  },
  REPLACE_PROP: {
    title: 'Click Replace Prop',
    content: 'Click Replace Prop button to see the similar products in our library.',
    styles: {
      width: '279px',
    },
    mainStep: GAMIFIED_STEPS.PRODUCT,
    progress: 10,
  },
  SELECT_PRODUCT: {
    title: 'Select Any Prop',
    content: 'Click on any prop to replace it with the selected product.',
    styles: {
      width: '279px',
    },
    mainStep: GAMIFIED_STEPS.PRODUCT,
    progress: 10,
  },
  CONGRATULATIONS: {
    title: 'Congratulations',
    styles: {
      width: '455px',
      left: 'calc(50% - 227.5px)',
      bottom: '30px',
      top: 'initial',
    },
    isPropReplaced: true,
    content:
      "Your prop change deserves a round of applause! Let's work together to give your product a fresh new style!",
    progress: 20,
    mainStep: GAMIFIED_STEPS.PRODUCT,
    icon: Clap,
  },
  STYLE_CLICK: {
    title: 'Click here to style',
    styles: {
      width: '279px',
    },
    progress: 20,
    isPropReplaced: true,
    content: 'You can try & customise different finishes from here.',
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  ADD_FINISH: {
    title: 'Apply new design',
    styles: {
      width: '279px',
    },
    content: 'Try different design on your selected product by clicking on them.',
    progress: 20,
    isPropReplaced: true,
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  GREAT_JOB: {
    title: 'Great job!',
    styles: {
      width: '455px',
      left: 'calc(50% - 227.5px)',
      bottom: '30px',
      top: 'initial',
    },
    content:
      "Changing the finish was just the beginning. Let's continue to elevate the space by updating the wall finish.",
    progress: 20,
    icon: Clap,
    isPropReplaced: true,
    isTextureApplied: true,
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  CLICK_ON_WALL: {
    title: 'Click on the wall',
    styles: {
      width: '279px',
      transform: 'translate(calc(-100% - 10px), -50%)',
    },
    progress: 40,
    content: 'Select wall & try some different finish.',
    isPropReplaced: true,
    isTextureApplied: true,
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  ADD_WALL_FINISH: {
    title: 'Add wall finish',
    styles: {
      width: '279px',
    },
    progress: 40,
    content: 'Let’s give this wall a new look.',
    isPropReplaced: true,
    isTextureApplied: true,
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  QUICK_MESSAGE: {
    title: 'Wow, that was quick!',
    styles: {
      width: '455px',
      left: 'calc(50% - 227.5px)',
      bottom: '30px',
      top: 'initial',
    },
    content: 'Changing the wall finish has given the room a whole new look in just seconds.',
    progress: 60,
    icon: Wow,
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  CLICK_ARROW: {
    title: 'Click the arrow to close',
    styles: {
      width: '280px',
    },
    progress: 60,
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    content:
      "When you're ready to move forward, just hit the arrow or style icon to close the style panel.",
    mainStep: GAMIFIED_STEPS.STYLE,
  },
  CLICK_AND_DRAG_TO_ROTATE: {
    title: 'Click & drag to look around',
    styles: {
      width: '290px',
      left: 'calc(50% - 145px)',
      top: 'calc(100% + 27px)',
    },
    progress: 70,
    content: 'You can change camera view to frame your hero product.',
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  CLICK_HERE_TO_CAMERA: {
    title: 'Click on Camera',
    styles: {
      width: '279px',
    },
    progress: 70,
    content: 'Here you can save & keep all your Camera Angles.',
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  ADD_SAVE_CAMERA: {
    title: 'Click to Add Camera',
    styles: {
      width: '279px',
    },
    progress: 80,
    content: 'You can capture current view from here & save for future use.',
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  GIVE_NAME_AND_SAVE: {
    title: 'Give it a Name and Save',
    styles: {
      width: '279px',
    },
    progress: 80,
    content: 'Let’s give a good name & hit enter to save this camera angle.',
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  ONE_STEP_TO_GO: {
    title: 'One step to go!',
    styles: {
      width: '455px',
      left: 'calc(50% - 227.5px)',
      bottom: '30px',
      top: 'initial',
    },
    progress: 90,
    content: 'Now we are all set to produce our 1st Image.',
    icon: oneStep,
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  RENDER: {
    title: 'Let’s Create your first image',
    styles: {
      width: '263px',
    },
    progress: 90,
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
  PRODUCE_IMAGE: {
    title: 'Click Create Image to produce your first image',
    styles: {
      width: '396px',
    },
    progress: 90,
    isPropReplaced: true,
    isTextureApplied: true,
    isOtherMaterialApplied: true,
    mainStep: GAMIFIED_STEPS.CAMERA,
  },
};
